<template>
  <div :asset-name="slug">
    <section class="signup-success">
      <div
        :class="{
          'container mx-auto my-6': true,
        }"
      >
        <h2
          :class="{
            'signup-title': true,
          }"
        >
          {{ signupTitle }}
        </h2>

        <div
          :class="{
            'signup-msg success-msg mt-32px': true,
            'flex justify-center': true,
          }"
        >
          <div
            :class="{
              'w-[462px] rounded-md border border-[#dcdfeb] transition-all duration-300 ease-in-out hover:border-www-color-primary-lighter hover:shadow-card': true,
            }"
          >
            <div
              :class="{
                'card-body p-[25px]': true,
              }"
            >
              <ImageAtom
                v-if="image"
                v-bind="image"
                loading="eager"
              />

              <h3
                :class="{
                  'mt-6 text-center text-lg font-bold': true,
                }"
              >
                {{ cardTitle }}
              </h3>

              <p
                :class="{
                  email: true,
                  'text-center': true,
                }"
              >
                {{ emailValue }}
              </p>
            </div>
            <div
              :class="{
                'card-footer flex flex-col items-center border-t border-[#dcdfeb] bg-[#dcdfeb] bg-opacity-20 p-[15px] text-www-color-neutral-medium-dark': true,
              }"
            >
              <h6
                :class="{
                  'text-15px font-medium': true,
                }"
              >
                {{ cardSubtitle }}
              </h6>

              <ul
                :class="{
                  'list-disc px-6': true,
                }"
              >
                <template
                  v-for="(item, i) in signupMessageList"
                  :key="i"
                >
                  <li
                    :class="{
                      'link w-fit text-13px': true,
                    }"
                  >
                    <CodeEmbed v-bind="item" />
                  </li>
                </template>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script lang="ts" setup>
import { FieldHtmlNameUtil } from '@onshape/www-inertia';
import ImageAtom from '~/components/Atmos/ImageAtom/ImageAtom.vue';
import CodeEmbed from '~/components/Atmos/CodeEmbed/CodeEmbed.vue';
import type UnifiedSignupSessionInfo from '~/hekate-www/external/facets/Form/coordinator/UnifiedSignup/session-info/UnifiedSignupSessionInfo';
import type SignupSubmittingSignupScreen from '~/hekate-www/external/facets/Form/coordinator/UnifiedSignup/screens/SignupSubmittingSignupScreen';
import type { UssMessage } from '~/sanity/types';

const props = defineProps<
  UssMessage & {
    signupScreen: SignupSubmittingSignupScreen;
    sessionInfo: UnifiedSignupSessionInfo;
  }
>();

const emit = defineEmits<{
  updatePage: [];
}>();

// Get email value from form field
const emailField = props.signupScreen.getField(FieldHtmlNameUtil.email);
const emailValue = computed(() => emailField.val as string);

onMounted(() => {
  // initWatchers just calls onUpdatePage to trigger form submission polling
  emit('updatePage');
});
const { slug } = useRoute().params;
</script>
